module.exports = __webpack_public_path__ + "img/level_four_hover.ab8c95d6.png";